import { Col, ContentLoader, Empty, Row } from "../../../components";
import { MenuItemCard } from "../../../layouts";
import { Item } from "../../../types/item";
import React, { useCallback } from "react";
import { Props } from "../viewModel";

const ItemCardSkeleton = ({ index }: { index: number }) => (
  <ContentLoader
    uniqueKey={`favorite-item-card-${index}`}
    viewBox="0 0 320 420"
    className="w-full"
    style={{ width: "100%", height: "auto" }}
  >
    <rect x="0" y="0" rx="12" ry="12" width="320" height="220" />
    <rect x="16" y="240" rx="4" ry="4" width="200" height="18" />
    <rect x="16" y="270" rx="4" ry="4" width="260" height="12" />
    <rect x="16" y="292" rx="4" ry="4" width="180" height="12" />
    <rect x="16" y="330" rx="4" ry="4" width="90" height="18" />
    <rect x="16" y="365" rx="8" ry="8" width="288" height="40" />
  </ContentLoader>
);

const Skeleton = () => (
  <Row
    gutter={[
      { xs: 8, lg: 16 },
      { xs: 8, lg: 16 },
    ]}
  >
    {React.Children.toArray(
      Array.from({ length: 6 }).map((_, index) => (
        <Col xs={24 / 2} sm={24 / 2} md={24 / 2} lg={24 / 3}>
          <ItemCardSkeleton index={index} />
        </Col>
      )),
    )}
  </Row>
);

const View = ({ items, loading, removeFavorite }: Props) => {
  const renderItem = useCallback(
    (item: Item) => {
      return (
        <Col xs={24 / 2} sm={24 / 2} md={24 / 2} lg={24 / 3}>
          <MenuItemCard
            {...item}
            favorite
            onFavorite={() => removeFavorite(item)}
          />
        </Col>
      );
    },
    [removeFavorite]
  );

  return loading ? (
    <Skeleton />
  ) : !!items.length ? (
    <Row
      gutter={[
        { xs: 8, lg: 16 },
        { xs: 8, lg: 16 },
      ]}
      children={React.Children.toArray(items.map(renderItem))}
    />
  ) : (
    <Empty
      className="p-50"
      style={{ background: "white" }}
      description="No favorites yet. Tap the heart to add dishes."
    />
  );
};

export default View;
